module.exports = __webpack_public_path__ + "img/fk.a6476c75.png";